import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const rentalValueTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "rental.value-trend",
  name: "Rental value by pickup date",
  description: "Rental value by pickup date across the selected period.",
  apps: [
    "rental",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "rental.orders",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "total_amount",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Rental value",
        query: {
          version: 1,
          source: "rental.orders",
          ...period(30),
          select: [
            {
              type: "field",
              field: "start_at",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "total_amount",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "start_at",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#2fb344",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Rental value by pickup date",
    valueFormat: "currency",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "0",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
